export default __webpack_public_path__ + "static/media/63.75c40cbb.png";